import { Link } from 'react-router';
import { Tag } from '../Tag/Tag';
import { Text } from '../Text/Text';
import {
  AccordionListItemProps,
  CheckboxListItemProps,
  RadioListItemProps,
} from './ListTypes';

type ListItemContentProps = Pick<
  CheckboxListItemProps & RadioListItemProps & AccordionListItemProps,
  'leadingElement' | 'linkTo' | 'heading' | 'body' | 'disabled'
> & { headingTag?: string };

export const ListItemContent = (props: ListItemContentProps) => {
  const { leadingElement, linkTo, heading, headingTag, body, disabled } = props;
  return (
    <>
      {leadingElement && <div className="self-start">{leadingElement}</div>}

      <div className="flex-col self-center grow">
        <div className="flex items-center gap-xs">
          {linkTo ? (
            <Link to={linkTo} aria-disabled={disabled}>
              <Text size="headingXS" color="primary">
                {heading}
              </Text>
            </Link>
          ) : (
            <Text size="headingXS">{heading}</Text>
          )}
          {headingTag && (
            <Tag intent="positive" size="xsmall">
              {headingTag}
            </Tag>
          )}
        </div>
        {typeof body === 'string' ? (
          <Text size="bodyS" color="contentSubdued">
            {body}
          </Text>
        ) : (
          body
        )}
      </div>
    </>
  );
};
